module.exports = __webpack_public_path__ + "static/media/Google_Button@3x.9709b056.png";